export default {
  students: [
    {
      id: 0,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/risha-das.jpg",
      bio:
        "You gotta know how dope you are without a validation, congratulations, or a celebration. 💜",
      fullname: "Risha Das",
      nicknames: [],
      years: [2001, 2016],
      extracurriculars: ["MUN", "Painting", "Karate", "Yoga"],
      teachers: [
        "Balaji da",
        "Ratna di",
        "Sushmita di(not zinky)",
        "Nilanjana di",
        "Soma di...."
      ],
      friends: [],
      misconduct: "Ya.... Plenty of times",
      social: { fb: "https://www.facebook.com/risha.das.92", insta: "" }
    },
    {
      id: 1,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/prangan-mukherjee.jpg",
      bio:
        /*"Wanted to prove to myself that I'm not as worthless as my whole school thought me to be. \nHave been able to achieve a real normal life in college, a real maturity in interacting with people, making friends and make myself presentable to the world all because of the hard times I have gone through after class 10 in Dolna. I'm more than happy and in peace of mind by getting a job now.\nFuture ? I would like to grow further in life, continue to be a sensible, funloving, crazy but responsible man and have a normal life ! \n*/"That's Praggy, your entertainment partner as always ❤️",
      fullname: "Prangan Mukherjee",
      nicknames: ["Praggy"],
      years: [2010, 2016],
      extracurriculars: ["Dance", "Karate"],
      teachers: ["Madhura di"],
      friends: [],
      misconduct: "Dude alwayssss 🤣🤣🤣",
      social: {
        fb: "https://www.facebook.com/prangan.mukherjee",
        insta: "https://www.instagram.com/praggy_97"
      }
    },
    {
      id: 2,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/srinjoy-santra.jpg",
      bio: "You shoot me down, but I won't fall. I'm Adamantium",
      fullname: "Srinjoy Santra",
      nicknames: ["Reek"],
      years: [1999, 2016],
      extracurriculars: [
        "MUN",
        "Painting",
        "Karate",
        "Yoga",
        "Football",
        "Quiz"
      ],
      teachers: ["Nilanjanadi", "Ratnadi", "Balajida", "Gargidi"],
      friends: ["Ritobroto", "Rohit", "Ambar", "Soham"],
      misconduct: "Once I was thrown out alongwith almost the entire class.",
      social: {
        fb: "https://www.facebook.com/srinjoy.santra.54",
        insta: "https://www.instagram.com/srinjoy_santra/"
      }
    },
    {
      id: 3,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/rajyasree-sarkar.jpg",
      bio: "Every life is worth saving.",
      fullname: "Rajyasree Sarkar",
      nicknames: ["Slow", "Mach 6"],
      years: [2001, 2016],
      extracurriculars: ["Painting", "Dance", "Karate", "Yoga"],
      teachers: ["Somadi", "Nilda", "Balajida", "Nilanjanadi"],
      friends: ["Subhechcha", "Soham"],
      misconduct:
        "Can't remember being thrown out of class. But definitely got scolded a lot of times.",
      social: { fb: "", insta: "https://www.instagram.com/rajyasree.cugo/" }
    },
    {
      id: 4,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/soham-palit.jpg",
      bio: "Carpe Diem",
      fullname: "Soham Palit",
      nicknames: [],
      years: [2001, 2016],
      extracurriculars: [],
      teachers: ["Nilanjana Di", "Suman da", "Balu"],
      friends: ["Onekei achen kake chere kar naam bolbo😆"],
      misconduct:
        "Yup quite a few times. Sob theke beshi mone porche ekbar paro boi na anar jonno onek k eksathe baar kore diyechilo and we had a. Gala time outside",
      social: { fb: "https://www.facebook.com/soham.palit.3", insta: "" }
    },
    {
      id: 5,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/ahana-mitra.jpg",
      bio: "Live & let live!",
      fullname: "Ahana Mitra",
      nicknames: ["Mitra"],
      years: [2010, 2016],
      extracurriculars: ["Painting"],
      teachers: ["Nilanjana Di."],
      friends: ["Ahona Rudra"],
      misconduct:
        "Yes!!! It was my math teacher's favorite thing to do coz i sucked in maths.",
      social: {
        fb: "https://www.facebook.com/ahana.mitra.16",
        insta: "https://www.instagram.com/meeshti_doii/"
      }
    },
    {
      id: 6,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/senjuti-kumar.jpg",
      bio: "Life is short. So am I.",
      fullname: "Senjuti Kumar",
      nicknames: [],
      years: [2001, 2016],
      extracurriculars: ["MUN"],
      teachers: ["Nilanjana di"],
      friends: [],
      misconduct: "4 or 5 times. Mostly for forgetting to bring stuff.",
      social: {
        fb: "https://www.facebook.com/senjuti.kumar",
        insta: "https://www.instagram.com/senjutikumar/"
      }
    },
    {
      id: 7,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/ahona-rudra.jpg",
      bio: "To live and let live",
      fullname: "Ahona Rudra",
      nicknames: ["Rudro"],
      years: [2000, 2016],
      extracurriculars: ["Choir", "Karate"],
      teachers: [
        "Nilanjana Di and her insight into life along with literature and Balaji Da for his witty sense of humour."
      ],
      friends: [
        "Ahana Mitra",
        "Priyadarshini Banerjee",
        "Roshni Chakraborty",
        "Ankana Dasgupta",
        "Debaditya Sarkar",
        "Saikat Bhattacharya."
      ],
      misconduct:
        "Never been thrown out of the class, but I vividly remember that on two occasions almost half of the class was sent outside due to unfinished homework in class 11. One was in Parvati Di's class and one was in Balaji Da's class. Fortunately or unfortunately, I wasn't one of the exceptions.",
      social: {
        fb: "https://www.facebook.com/ahona.rudra.3",
        insta: "https://www.instagram.com/agathokakalogical/"
      }
    },
    {
      id: 8,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/debaditya-sarkar.jpg",
      bio:
        'I always tend to follow my dreams and my dream is to be a successful businessman.  I hope to achieve it one day.  My favourite quote that motivates me is "All our dreams can come true, if we have the courage to pursue them" by Walt Disney.',
      fullname: "Debaditya Sarkar",
      nicknames: ["Rahul", "Deba"],
      years: [2001, 2016],
      extracurriculars: ["Choir", "Painting", "Karate"],
      teachers: ["Nilanjana Di", "Balaji Da", "Suman Da", "Neil Da."],
      friends: ["Rajdeep", "Saikat", "Amritabha", "Sohom", "Subhechcha."],
      misconduct:
        "Hhahahaha! Good question.  I think I've been thrown out of the class the most number of times as I was the most notorious one.  For disturbing classes and for not doing homework.  😅",
      social: {
        fb: "https://www.facebook.com/Gamer.rahul",
        insta: "https://www.instagram.com/rahul_xaverino/"
      }
    },
    {
      id: 9,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/amritabha-maity.jpg",
      bio: "The problem with introspection is that , it has no end .",
      fullname: "Amritabha Maity",
      nicknames: ["Vicky", "Amri"],
      years: [2000, 2016],
      extracurriculars: [
        "Dance",
        "Karate",
        "Yoga",
        "Table tennis",
        "Football",
        "Cricket ."
      ],
      teachers: ["Nilanjana di", "Meera di", "Soma di", "Ratna di"],
      friends: [
        "Saikat",
        "Deba",
        "Rajdeep",
        "Siddharth",
        "Raunak",
        "Rohit",
        "Dikshak",
        "Ambar",
        "Vishrut",
        "Soham",
        "Arani",
        "Pratik",
        "Srinjoy",
        "Ritobroto ."
      ],
      misconduct:
        "Always an OUT - STANDING student be it Parvati di's class or Suparna di's !! So much that they asked for a passport sized picture of me incase I become untraceable or simply disappear .",
      social: {
        fb: "https://www.facebook.com/DubStePpz",
        insta: "https://www.instagram.com/xave9850/"
      }
    },
    {
      id: 10,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/ambar-chatterjee.jpg",
      bio: "Aati ka khandala.",
      fullname: "Ambar Chatterjee",
      nicknames: [],
      years: [2005, 2016],
      extracurriculars: ["Karate"],
      teachers: [],
      friends: [],
      misconduct: "",
      social: { fb: "", insta: "" }
    },
    {
      id: 11,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/rohit-iyer.jpg",
      bio: "-",
      fullname: "Rohit Iyer",
      nicknames: ["Iyo"],
      years: [2000, 2014],
      extracurriculars: ["Nil"],
      teachers: ["nil"],
      friends: ["nil"],
      misconduct: "",
      social: { fb: "", insta: "" }
    },
    {
      id: 12,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/dyuti-roy.jpg",
      bio:
        'Differential, glad to be of use, Politic, cautious and meticulous; Full of high sentence, but a bit obtuse; At times indeed almost ridiculous--Almost, at times, the fool." ~T. S. Eliot.',
      fullname: "Dyuti Roy",
      nicknames: ["Dyuti (or don't remember)"],
      years: [2000, 2014],
      extracurriculars: ["Choir", "Dance", "Dealing books like drugs."],
      teachers: ["Nilanjana Di (obviously)"],
      friends: ["Shokto proshnor uttor ami di ni!"],
      misconduct: "Probably a number of times.",
      social: {
        fb: "https://www.facebook.com/dyuti.98",
        insta: "https://www.instagram.com/_.dyuti._/"
      }
    },
    {
      id: 13,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/pratik-pujari.jpg",
      bio: "Let it rip 😎",
      fullname: "Pratik Pujari",
      nicknames: ["Better not remind myself of that 😂"],
      years: [2001, 2014],
      extracurriculars: [
        "MUN",
        "Choir",
        "Karate",
        "Yoga",
        "Rowing",
        "Badminton"
      ],
      teachers: [
        "Ratna Di",
        "Nilanjana Di",
        "Balaji da",
        "Sushmita di(Bengali)",
        "Arpita Di"
      ],
      friends: [
        "(Not in any order)Arani",
        "Subhechha",
        "Soham",
        "Rajyasree",
        "Pritha",
        "Debaditya",
        "Dikshak",
        "Amritabha"
      ],
      misconduct:
        "Many times.\nI was whistling in Suparna di’s class. \nI was talking to Arani in Parvati Di’s class, both got thrown out. \nSoma di threw some of us out in class 6. Jali even got slapped as far as I remember. 😂",
      social: {
        fb: "https://www.facebook.com/aakash.pujari.14",
        insta: "https://www.instagram.com/proooooootik/"
      }
    },
    {
      id: 14,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/saikat-bhattacharyya.jpg",
      bio: "Walk slow, walk alone, but don't stop walking.",
      fullname: "Saikat Bhattacharyya",
      nicknames: [
        "tolgay (too much tilting motion when i was small, unsure about spelling)"
      ],
      years: [2000, 2016],
      extracurriculars: [
        "Karate",
        "Tabletennis",
        "Football (with socks - anyway I was goalkeeper)"
      ],
      teachers: ["Nilanjanadi", "Abhisekda"],
      friends: [
        "Debaditya",
        "Amritabha",
        "Rajdeep",
        "Raunak",
        "Siddharth",
        "everyone else",
        "Sourish Dutta"
      ],
      misconduct:
        "Parbatidi class, mostly because never brought book/copy. Far too many times to even count.",
      social: {
        fb: "https://www.facebook.com/kakashi28",
        insta: "https://www.instagram.com/sai_intrexon/"
      }
    },
    {
      id: 15,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/pritha-saha.jpg",
      bio: "Live and let live",
      fullname: "Pritha Saha",
      nicknames: ["Aaheli"],
      years: [2004, 2016],
      extracurriculars: ["Choir", "Dance", "Karate", "Yoga"],
      teachers: [
        "Madhuradi",
        "Parvatidi",
        "Neelanjanadi",
        "Balajida",
        "Sushmitadi"
      ],
      friends: [],
      misconduct: "Yes, for not bringing graph book in Balajida's class.",
      social: {
        fb: "https://www.facebook.com/pritha.saha.1",
        insta: "https://www.instagram.com/pritha_aaheli"
      }
    },
    {
      id: 16,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/arpita-choudhury.jpg",
      bio: "Carpe Diem",
      fullname: "Arpita Choudhury",
      nicknames: ["Arpu"],
      years: [2000, 2016],
      extracurriculars: ["MUN", "Choir", "Yoga"],
      teachers: [
        "Parvati Di",
        "Oendrila Di",
        "Madhura Di",
        "Balaji da",
        "Susmita Di (Beng) and many more....."
      ],
      friends: [
        "Sohini",
        "Mahima",
        "Debaditya",
        "Subhechcha",
        "Soham.... It's a never ending one"
      ],
      misconduct: "Thrown out.... Nah... But bunked n th times",
      social: { fb: "https://www.facebook.com/ArpitaChoudhury97", insta: "" }
    },
    {
      id: 17,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
      //  "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/rajdeep-banerjee.jpg",
      bio: "Language enthusiast.",
      fullname: "Rajdeep Banerjee",
      nicknames: [],
      years: [2001, 2016],
      extracurriculars: [],
      teachers: [
        "Nilanjana Di",
        "Soma Di",
        "Ratna Di and Sushmita Di ( Bangla)"
      ],
      friends: [
        "Saikat",
        "Soham",
        "Amritabha",
        "Debaditya",
        "Poulami",
        "Dyuti",
        "Ahana Mitra",
        "Ahona Rudra."
      ],
      misconduct:
        "Yes. \nReasons: I didn't bring my notebook/ C.W copies or for talking a lot during Parbati Di's class.",
      social: { fb: "", insta: "" }
    },
    {
      id: 18,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
      //  "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/dikshak-khanna.jpg",
      bio: "Never change XD",
      fullname: "Dikshak Khanna",
      nicknames: ["Dicksuck being one of the most famous ones."],
      years: [2003, 2014],
      extracurriculars: ["Dance", "Karate"],
      teachers: ["Meera di", "Parvati di", "Balaji da."],
      friends: ["Whole batch was my favourite"],
      misconduct: "Yes. Favourite one being by Jyotishko da for a month.",
      social: {
        fb: "https://www.facebook.com/dikshak.khanna.7",
        insta: "https://instagram.com/dikshak_k"
      }
    },
    {
      id: 19,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
      //  "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/arani-mukherjee.jpg",
      bio: "Keep smiling",
      fullname: "Arani Mukherjee",
      nicknames: ["Ron"],
      years: [2001, 2016],
      extracurriculars: ["MUN"],
      teachers: ["Free periods"],
      friends: ["Pratik pujari"],
      misconduct: "3 times a week",
      social: { fb: "", insta: "" }
    },
    {
      id: 20,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/megha-sharma.jpg",
      bio: "Follow the notes of your heart to sing the happy song of life.",
      fullname: "Megha Sharma",
      nicknames: [],
      years: [1998, 2016],
      extracurriculars: ["Choir", "Karate"],
      teachers: ["Nilanjana di"],
      friends: ["Aishee Chakraborty."],
      misconduct: "",
      social: {
        fb: "https://www.facebook.com/profile.php?id=100004905121435",
        insta: ""
      }
    },
    {
      id: 21,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/poulami-sengupta.jpg",
      bio:
        "Live. Love. Laugh.",
      fullname: "Poulami Sengupta",
      nicknames: ["Pela", "Polau", "Polo"],
      years: [2008, 2016],
      extracurriculars: ["Choir", "Painting", "Dance", "Karate"],
      teachers: [
        "Ratna Di",
        "Nilabja Da",
        "Oindrila di",
        "Nilanjana Di",
        "Madhuradi",
        "Parvati di",
        "Suparna di and the list goes on.."
      ],
      friends: ["Pritha Saha", "Rajdeep Banerjee", "Amritabho Maity"],
      misconduct:
        "Once or twice maybe. Dont exactly remember. But remember being on Parvati di's bad book for the whole class 10 as I dont recollect sitting on my bench when she completed 'As You Like It'.",
      social: {
        fb: "https://www.facebook.com/poulami.sengupta.35",
        insta: "https://instagram.com/poulamisg"
      }
    },
    {
      id: 22,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/mohana-deb.jpg",
      bio: "Here for the memories 😎",
      fullname: "Mohana Deb",
      nicknames: ["DEB"],
      years: [2000, 2016],
      extracurriculars: ["Painting", "Yoga"],
      teachers: ["Nilanjana Di", "Balaji Da", "Ritali Di", "Soma Di"],
      friends: [],
      misconduct: "",
      social: {
        fb: "https://www.facebook.com/mohana.deb.7",
        insta: "https://instagram.com/_mohanaa___"
      }
    },
    {
      id: 23,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/sohini-dasgupta.jpg",
      bio: "Always be happy",
      fullname: "Sohini Dasgupta",
      nicknames: ["Sohu"],
      years: [2001, 2016],
      extracurriculars: ["MUN", "Choir"],
      teachers: [
        "Nilanjana Di",
        "balaji DA",
        "madhuradi",
        "jyotishko DA",
        "soma di"
      ],
      friends: ["All"],
      misconduct: "No",
      social: {
        fb: "https://www.facebook.com/dasgupta.sohini.3",
        insta: "https://www.instagram.com/sohini_9720"
      }
    },
    {
      id: 24,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/priyadarshini-banerjee.jpg",
      bio: "Currently a fourth year student studying Pharmacy",
      fullname: "Priyadarshini Banerjee",
      nicknames: ["Guddi"],
      years: [1999, 2014],
      extracurriculars: ["Painting", "Debate", "Dance"],
      teachers: ["Shoma Di"],
      friends: ["Ankana", "Roshni", "Ahana", "Ahona"],
      misconduct: "Yes",
      social: { fb: "", insta: "" }
    },
    {
      id: 25,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/sayani-basu.jpg",
      bio: "Hotelier, reader, animal lover",
      fullname: "Sayani Basu",
      nicknames: ["Rani"],
      years: [2001, 2016],
      extracurriculars: ["Karate", "Yoga", "Guitar"],
      teachers: [
        "Gargi-di",
        "Soma-di",
        "Madhura-di",
        "Balaji-da",
        "Sushmita-di (Ben)"
      ],
      friends: [],
      misconduct: [],
      social: { fb: "https://www.facebook.com/sayani.basu.188478", insta: "" }
    },
    {
      id: 26,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
        //"https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/debadyuti-guha thakurata.jpg",
      bio: "Life is a crazy journey, keep exploring till you die.",
      fullname: "Debadyuti Guha Thakurata",
      nicknames: [],
      years: [2001, 2014],
      extracurriculars: [
        "MUN",
        "Debate",
        "Karate",
        "Quiz Club",
        "Table tennis"
      ],
      teachers: ["Nilanjana Di", "Parvati di", "Balaji Da"],
      friends: [],
      misconduct:
        "Yes, Forgetting to bring Bengali poetry book, Answering homework questions from a blank copy, playing TT for too long",
      social: {
        fb: "https://www.facebook.com/alexander.thompson.507",
        insta: "https://www.instagram.com/alex.debadyuti"
      }
    },
    {
      id: 27,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/mahima-chaki.jpg",
      bio: "Keeping it short to save time since forever:) (pun intented)",
      fullname: "Mahima Chaki",
      nicknames: ["Chaki"],
      years: [2004, 2014],
      extracurriculars: ["MUN", "Just remember studying."],
      teachers: ["Susmita Di", "Nilanjana Di", "Arpita Di", "Parvati Di"],
      friends: ["Arpita", "Dikshak", "Dyuti", "Sohini"],
      misconduct: "Nope.",
      social: { fb: "", insta: "" }
    },
    {
      id: 28,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
        //"https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/siddharth-banerjee.jpg",
      bio: "Always encourage urself to achieve greater aspects of life",
      fullname: "Siddharth Banerjee",
      nicknames: ["Sid"],
      years: [2002, 2016],
      extracurriculars: ["Karate"],
      teachers: ["Nilanjana Di and Parwati Di"],
      friends: ["Amritabha Simontini"],
      misconduct: "Many time due to mischevious activities of my friends",
      social: { fb: "", insta: "" }
    },
    {
      id: 29,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/sreemoyee-mukherjee.jpg",
      bio: "Work hard for a better tomorrow, but don't forget to enjoy today!",
      fullname: "Sreemoyee Mukherjee",
      nicknames: [],
      years: [2000, 2014],
      extracurriculars: ["MUN"],
      teachers: ["Gargidi Nilanjanadi"],
      friends: ["Suchandra Prattusha Risha Asmita Medha"],
      misconduct: "Yeah... But I really don't remember the instances :p",
      social: {
        fb: "https://www.facebook.com/sreemoyee.mukherjee.56",
        insta: "https://www.instagram.com/sreemoyee97/"
      }
    },
    {
      id: 30,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/raunak-rakshit.jpg",
      bio: "To make a mark in life",
      fullname: "Raunak Rakshit",
      nicknames: ["Balu", "Jeet"],
      years: [2001, 2016],
      extracurriculars: ["Choir", "Painting"],
      teachers: ["Nilanjana Di and Suman Da"],
      friends: [
        "Saikat",
        "Rajdeep",
        "Amritabho",
        "Debaditya",
        "Siddharth",
        "Ambar"
      ],
      misconduct:
        "Yaa very frequently we used to get punishments..Mainly in the english classes in 12 where I,saikat,deba,amri,sidd were often sent out of the class.",
      social: {
        fb: "https://www.facebook.com/raunak.rakshit.14",
        insta: "https://www.instagram.com/raunakrakshit/"
      }
    },
    {
      id: 31,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/roshni-chakraborty.jpg",
      bio: "Even I am looking for a bio.",
      fullname: "Roshni Chakraborty",
      nicknames: ["Rosh"],
      years: [2000, 2016],
      extracurriculars: ["Gossiping. XD"],
      teachers: ["Neelanjana di"],
      friends: [
        "Priyadarshini Banerjee",
        "Ankana Dasgupta",
        "Ahana Mitra",
        "Ahona Rudra"
      ],
      misconduct: "Many a times.",
      social: {
        fb: "https://www.facebook.com/roshni.chakraborty.50",
        insta: ""
      }
    },
    {
      id: 32,
      profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
      //  "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/vishrut-shrivastava.jpg",
      bio:
        "Nothing in life is as important as you think it is, while you are thinking about it.",
      fullname: "Vishrut Shrivastava",
      nicknames: ["Vishi"],
      years: [2004, 2014],
      extracurriculars: ["Painting", "Karate", "Yoga"],
      teachers: ["Mira Di"],
      friends: ["Dikshak Amritabha Dyuti Roshni Ankana Rohit Ambar"],
      misconduct: "Yes",
      social: {
        fb: "https://www.facebook.com/shrivastava.vishrut",
        insta: "https://instagram.com/iamviraj_1"
      }
    },
    {
      id: 33,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/subhechcha-sadhu.jpg",
      bio: "The rules are wrong",
      fullname: "Subhechcha Sadhu",
      nicknames: ["Sadhu"],
      years: [2001, 2016],
      extracurriculars: ["MUN", "Choir", "Dance", "Karate", "Yoga"],
      teachers: ["Nilanjana di", "Balaji da", "Soma di", "Gargi di"],
      friends: ["Rajyasree"],
      misconduct:
        "Yes! Quite a few number of times as opposed to the popular beliefs 😂",
      social: { fb: "https://www.facebook.com/subhechcha.sadhu", insta: "" }
    },
    {
      id: 34,
      profileImg:
        "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/asmita-paul.jpg",
      bio: "Invest in urself",
      fullname: "Asmita Paul",
      nicknames: ["Mishti", "tinni", "mumpi"],
      years: [2002, 2016],
      extracurriculars: ["Choir"],
      teachers: ["None."],
      friends: ["Everyone was my favourite in their own way."],
      misconduct: "No",
      social: { fb: "", insta: "" }
    },
    {
        id: 35,
        profileImg: "https://source.unsplash.com/jQJqzNLBK04/270X405",
        //  "https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/ritobroto-banerjee.jpg",
        bio: "Rito",
        fullname: "Ritobroto Banerjee",
        nicknames: ["Rito"],
        years: [2001, 2016],
        extracurriculars: ["MUN", "Debate"],
        teachers: ["Nilanjandi", "Balajida", "Swarnalidi", "Shushmitadi (beng.)", "Jyotishkoda"],
        friends: ["Arani", "Soham", "Srinjoy"],
        misconduct: "Quite a few times. I was the classic late latiff of school.",
        social: { fb: "", insta: "" }
      }
  ]
};


/*
    {
      id: 100,
      profileImg: "https://source.unsplash.com/Yd9tGOc8Gi0/270X405",
      bio: "A serpentine libertine in quarantine without nicotine",
      fullname: "Elizabeth Betty Cooper",
      nicknames: ["Bet", "Coop"],
      years: [1941, 2014],
      extracurriculars: ["music", "baseball", "cooking"],
      teachers: ["Mr. Dilton", "Mr. Marley"],
      friends: ["Veronica", "Jughead"],
      misconduct: "Countless occasions",
      social: {
        fb: "https://www.facebook.com/",
        insta: "https://www.instagram.com/"
      }
    },
    {
      id: 101,
      profileImg: "https://source.unsplash.com/Py8F6-hRn5o/270X405",
      bio: "I am sexy and I know it",
      fullname: "Archibald Andrews",
      nicknames: ["Arch"],
      years: [1942, 2015],
      extracurriculars: ["basketball", "baseball", "music"],
      teachers: ["Mr. Marley", "Mrs. Dilton"],
      friends: ["Betty", "Jughead"],
      misconduct: "Countless occasions",
      social: {
        fb: "https://www.facebook.com/",
        insta: "https://www.instagram.com/"
      }
    },
    {
      id: 102,
      profileImg: "https://source.unsplash.com/Py8F6-hRn5o/270X405",
      bio: "Due",
      fullname: "Archibald Andrews",
      nicknames: ["Arch"],
      years: [1942, 2015],
      extracurriculars: ["basketball", "baseball", "music"],
      teachers: ["Mr. Marley", "Mrs. Dilton"],
      friends: ["Betty", "Jughead"],
      misconduct: "Countless occasions",
      social: {
        fb: "https://www.facebook.com/",
        insta: "https://www.instagram.com/"
      }
    },
    */


// WEBPACK FOOTER //
// ./src/data/students.js